import React from 'react';

import {connectionURL} from 'instruments/connections/ConnectionDAO';
import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import {apiIdToIconName} from 'util/APIUtil';

import SmartChip from './SmartChip';
import useSmartChipQuery, {SmartChipType} from './useSmartChipQuery';

export default function ConnectionChip(props: SharedSmartChipProps<SmartChipType.CONNECTION>): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: connection,
    handleClickLink,
    isInaccessible,
    itemUrl: connectionUrl,
  } = useSmartChipQuery<SmartChipType.CONNECTION>({
    id,
    onClick,
    getUrlFn: ({id}) => connectionURL(id),
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={connection != null ? apiIdToIconName(connection.id) : null}
      isInaccessible={isInaccessible}
      item={connection}
      onClick={handleClickLink}
      url={connectionUrl}
    />
  );
}
